import React, { useState, useEffect } from "react";
import "./Partnership.css";
import { partner } from "../data/Data";

const Partnership = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // State to control the visibility of the modal
  const [showModal, setShowModal] = useState(false);
  // State to keep track of the selected partner
  const [selectedPartner, setSelectedPartner] = useState(null);

  // Function to open the modal and set the selected partner
  const openModal = (partner) => {
    setSelectedPartner(partner);
    setShowModal(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setShowModal(false);
  };

  // Close modal when clicking outside
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      <div>
        <section className="partnership_crumb_area">
          <div className="container text-center">
            <div className="partner_content">
              <h1 className="text-white text-4xl font-bold mb-8">Partner</h1>
              <p className="text-white text-lg">
                According to the World Bank Institute the two critical elements in meeting the Millennium Development Goal are to increase access to finance, trade, knowledge and expertise about development and to equip people to adapt and apply it to their local circumstances. BAZRA INVESTMENT GROUP then help to build local capacity through business and financial partnership, training and mentoring, giving international business and financial policy analysis services and knowledge sharing activities, and knowledge networks targeted to the needs of a wide range of businesses.
                BAZRA INVESTMENT GROUP is dedicated to forging international and local partnerships to develop, support and improve international business in Ethiopia. BAZRA INVESTMENT GROUP works with key stakeholders in the automotive, biopharmaceuticals and IT fields and its networking role will be increasingly important in the arena of international business in Ethiopia. BAZRA INVESTMENT GROUP is working to develop partnership in diverse areas of international business and trade, knowledge and technology transfer, research, technical exchange, training and mentoring with the businesses in Ethiopia and elsewhere to respond to pressing needs in international business, finance, trading and logistics. 
              </p>
            </div>
          </div>
        </section>

        <div className="page-wrapper">
          <div className="container">
            {partner.map((partnerGroup, index) => (
              <section key={index} className="partner-section">
                <div className="row">
                  {index % 2 === 0 ? (
                    <>
                      <div className="column main">
                        <img src={partnerGroup.images} alt="" />
                        <h2>{partnerGroup.category}</h2>
                      </div>
                      <div className="column">
                        <div className="inner-section">
                          <div className="row">
                            {partnerGroup.partners.map((partner, innerIndex) => (
                              <div key={innerIndex} className="column" onClick={() => openModal(partner)}>
                                <a>
                                  <img src={partner.image_src} alt="" />
                                </a>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="column">
                        <div className="inner-section">
                          <div className="row">
                            {partnerGroup.partners.map((partner, innerIndex) => (
                              <div key={innerIndex} className="column" onClick={() => openModal(partner)}>
                                <a>
                                  <img src={partner.image_src} alt="" />
                                </a>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="column main">
                        <img src={partnerGroup.images} alt="" />
                        <h2>{partnerGroup.category}</h2>
                      </div>
                    </>
                  )}
                </div>
              </section>
            ))}
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div 
            className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={handleBackdropClick}
          >
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md max-h-[90vh] flex flex-col">
              {/* Close button - fixed at top right */}
              <div className="flex justify-end p-4 sticky top-0 bg-white z-10 border-b border-gray-200">
                <button 
                  className="text-gray-500 hover:text-gray-700 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200 transition-colors"
                  onClick={closeModal}
                >
                  &times;
                </button>
              </div>
              
              {/* Modal content - scrollable */}
              {selectedPartner && (
                <div className="flex-1 overflow-y-auto">
                  <div className="p-6">
                    {/* Fixed size image container */}
                    <div className="mb-4 flex justify-center">
                      <div className="w-48 h-48 flex items-center justify-center bg-gray-100 rounded-lg overflow-hidden">
                        <img 
                          src={selectedPartner.image_src} 
                          alt={selectedPartner.name || "Partner image"} 
                          className="w-full h-full object-contain p-2"
                        />
                      </div>
                    </div>
                    
                    {/* Scrollable description */}
                    <div className="max-h-64 overflow-y-auto">
                      <p className="text-gray-700 leading-relaxed">
                        {selectedPartner.description}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Partnership;